import styled from "styled-components";
import MiniLoader from "../../../utils/MIniLoader";
import { useState } from "react";
import { Button } from "../../../styles";
import { ICON_CREDIT_CARD, ICON_MASTERCARD, ICON_VISA } from "../../../utils/icons";
import { useUserContext } from "../../../context/user_context";
import { useEffect } from "react";
import { naira } from "../../../utils/data";




const BillingDetails = () => {

      const [load, setLoad] = useState(false);

      const { userBalance, getUserBalance, loadingBalance } = useUserContext();


      useEffect(() => {
            getUserBalance();
      }, []);

      return (
            <StyledBillingDetails>

                  {/* Billing Details */}

                  <div className="mt-3">
                        <div className=" pry-bold-text">
                              <h5 className='m-0 p-0'>
                                    Billing Details
                              </h5>
                              <p className='m-0 p-0'>
                                    Payment and billing information for this team Account
                              </p>
                        </div>
                        <div className="border border-primary py-4 container br-md mt-3 pry-bold-text">
                              <h5 className='border-bottom border-primary pb-2'>
                                    Payment information
                              </h5>
                              <div className="row justify-content-start">
                                    <div className="col-12 col-md-2">
                                          <p>Payment method:

                                          </p>
                                    </div>
                                    <div className="col-12 col-md-6 fw-bold">
                                          <p className='m-0 mb-2'>
                                                a.     Reni Account
                                          </p>
                                          <span className="small sec br-md py-2 px-3">Balance:
                                                {loadingBalance ?
                                                      <MiniLoader
                                                            load={loadingBalance}
                                                            size={'15'}
                                                      /> :
                                                      <>
                                                            {' '}  {naira}{userBalance?.balance_th}
                                                      </>

                                                }

                                          </span>

                                          <p className='m-0 mt-4'>
                                                b.    Card Payment
                                          </p>
                                          <div className="d-flex align-items-center mr-3 gap-3 h3">
                                                {ICON_CREDIT_CARD}
                                                {ICON_VISA}
                                                {ICON_MASTERCARD}
                                          </div>

                                    </div>
                              </div>

                              <div className="mt-4">
                                    <a >
                                          <Button pry className='btn w-md-100'
                                          // onClick={(e) => fundConfirm(e)}
                                          > Fund Account</Button>
                                    </a>
                              </div>
                        </div>
                  </div>

                  {/* Billing Details */}


                  {/* Billinf Info */}

                  <div className="mt-5">

                        <div className="border border-primary py-4 container br-md mt-3 pry-bold-text">
                              <h5 className='border-bottom border-primary pb-2'>
                                    Billing Information
                              </h5>
                              <div className="row justify-content-start mt-4">
                                    <div className="col-3 col-md-2">
                                          <p>Name:

                                          </p>
                                    </div>
                                    <div className="col-6 fw-bold">
                                          <p className='m-0 mb-2'>
                                                Jane Doe
                                          </p>
                                    </div>
                              </div>
                              <div className="row justify-content-start">
                                    <div className="col-3 col-md-2">
                                          <p>Phone:

                                          </p>
                                    </div>
                                    <div className="col-6 fw-bold">
                                          <p className='m-0 mb-2'>
                                                12345678909
                                          </p>
                                    </div>
                              </div>
                              <div className="row justify-content-start">
                                    <div className="col-3 col-md-2">
                                          <p>Address:

                                          </p>
                                    </div>
                                    <div className="col-6 fw-bold">
                                          <p className='m-0 mb-2'>
                                                Aja, Lagos

                                          </p>
                                    </div>
                              </div>
                              <div className="mt-4">
                                    <Button pry className='btn w-md-100' disabled> Edit Billing Info</Button>
                              </div>
                        </div>
                  </div>

                  {/* Billinf Info */}

            </StyledBillingDetails>
      );
};

export default BillingDetails;

const StyledBillingDetails = styled.section`
      

` ;